import React from 'react';
import styles from '../shared/TipComponents.module.scss';

/* Components */
import { ProductContainer } from '../../../shared/components/ProductContainer/ProductContainer';
import { TipHeader } from '../../components/TipHeader/TipHeader';
import { TipBox } from '../../components/TipBox/Box/TipBox';
import { TipCouponInfo } from '../../components/TipCouponInfo/TipCouponInfo';
import { LockedTipBoxTop } from '../../components/TipBox/Top/LockedTipBoxTop';
import { UnavailableTipBoxTop } from '../../components/TipBox/Top/UnavailableTipBoxTop';

/* Interfaces */
import { PremiumTipProduct, Tipster } from '../../interfaces/TipProduct';

interface PremiumTipProps {
  tipster: Tipster;
  tip: PremiumTipProduct;
}

export const PremiumTipComponent: React.FC<PremiumTipProps> = ({
  tipster,
  tip,
}) => {
  return (
    <>
      <ProductContainer>
        <div className={styles.container}>
          <TipHeader type={tip.priceType} />

          <TipBox>
            {tip.checkAvailability().isAvailable ? (
              <LockedTipBoxTop />
            ) : (
              <UnavailableTipBoxTop />
            )}
          </TipBox>

          <TipCouponInfo />
        </div>
      </ProductContainer>
    </>
  );
};
